import { useStatelessLocalStorage } from './use-local-storage';

export default function useReturnPath
(initialValue?: string){
    return useStatelessLocalStorage<string>('returnPath', initialValue);
}